import { render, staticRenderFns } from "./IarcFooter.vue?vue&type=template&id=697541ff"
import script from "./IarcFooter.vue?vue&type=script&lang=js"
export * from "./IarcFooter.vue?vue&type=script&lang=js"
import style0 from "./IarcFooter.vue?vue&type=style&index=0&id=697541ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports